import { computed } from 'vue';
import { useI18n } from '@/hooks/useI18n.ts';
import { useAccountStore } from '@/store/modules/account/store.js';

export const useNiotextLabel = () => {
    const { t } = useI18n();
    const contextAccount = computed<{ sms_module?: boolean } | null>(
        () => useAccountStore().contextAccount
    );

    const label = (niotextKey: string, smsKey: string): string => {
        if (contextAccount.value?.sms_module) {
            return t(smsKey);
        }

        return t(niotextKey);
    };

    return { label };
};
